import React, { useEffect, useState } from "react";
import Header from "../../Components/Header/Header";
import MobHeader from "../../Components/Header/MobHeader";
import { Button, Col, Divider, Drawer, Row, Space } from "antd";
import {
  ThemeButton,
  ThemeDrawer,
  ThemeFilterBtn,
  ThemeForm,
  ThemeInput,
  ThemeMainWrapper,
  ThemeTitle,
  XThemeSelect,
} from "../Styles/Theme";
import {
  CardDropdown,
  DefaultGptCard,
  DefaultGptSuggestionsCard,
  DefaultSessionDrawer,
  HistoryItem,
  HistoryList,
  LibraryList,
  ProjectChatSessionsDetailsCard,
  ProjectFiles,
  ProjectSuggestionsTitle,
} from "./ProjectsStyle";
import {
  ArrowUpOutlined,
  CloseCircleFilled,
  CloseOutlined,
  InboxOutlined,
  MoreOutlined,
  PlusSquareFilled,
  SearchOutlined,
  SendOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import Squares from "../Dashboard/Squares";
import { PromptSection } from "../Surveys/LaunchSurvey.style";
import ChatBox from "../../Components/ChatBox";
import { ThemeModal } from "../Styles/Theme";
const DefaultGpt = () => {
  const navigate = useNavigate();
  // useEffect(() => {
  //   document.body.classList.add("");
  //   return () => {
  //     document.body.classList.remove("");
  //   };
  // }, []);

  const [isMobile, setIsMobile] = useState(false);

  const [historyOpen, setHistoryOpen] = useState(false);
  const showHistoryDrawer = () => {
    setHistoryOpen(true);
  };
  const onHistoryClose = () => {
    setHistoryOpen(false);
  };

  const [promptLibraryOpen, setPromptLibraryOpen] = useState(false);
  const showPromptLibraryDrawer = () => {
    setPromptBuilderOpen(false);
    setPromptLibraryOpen(true);
  };
  const onPromptLibraryClose = () => {
    setPromptLibraryOpen(false);
  };

  const [promptUpload, setPromptUpload] = useState(false);
  const showPromptUploadDrawer = () => {
    setPromptUpload(true);
  };
  const onPromptUploadClose = () => {
    setPromptUpload(false);
  };

  const [promptBuilderOpen, setPromptBuilderOpen] = useState(false);
  const showPromptBuilder = () => {
    setPromptBuilderOpen(true);
  };
  const onPromptBuilderClose = () => {
    setPromptBuilderOpen(false);
  };

  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkIsMobile();
    window.addEventListener("resize", checkIsMobile);
    return () => {
      window.removeEventListener("resize", checkIsMobile);
    };
  }, []);

  return (
    <>
      <MobHeader />
      <ThemeMainWrapper
        className="hasHeader"
        title={
          <Space>
            <ThemeFilterBtn
              className="shadow"
              onClick={() => navigate(-1)}
              size="middle"
              icon={<img src="/images/back-icon.svg" alt="Back" />}
            />
            SAM Project
          </Space>
        }
        extra={
          <Space gap={16}>
            <ThemeFilterBtn
              size="large"
              shape="square"
              icon={<img src="/images/select-uploaded-files-icon.svg" alt="Select Uploaded Files" />}
              onClick={showPromptUploadDrawer}
            >
              Select Uploaded Files
            </ThemeFilterBtn>
            <ThemeFilterBtn
              size="large"
              shape="square"
              icon={<img src="/images/history-icon.svg" alt="History" />}
              onClick={showHistoryDrawer}
            >
              History
            </ThemeFilterBtn>
          </Space>          
        }
      >
          <DefaultGptCard className="noFlex">
            <Row gutter={[16, 16]}>
              <Col
                xs={{ span: 24, offset: 0 }}
                sm={{ span: 24, offset: 0 }}
                md={{ span: 20, offset: 2 }}
                lg={{ span: 20, offset: 2 }}
                xl={{ span: 16, offset: 4 }}
                xxl={{ span: 12, offset: 6 }}
              >
                <div className="mainTitle mb-3">Analyze</div>
                <span className="subTitle">Short description add here</span>

                <PromptSection className="pt-4">
                  <ChatBox
                    placeholder="Ask anything about your project"
                    minHeight={40}
                    acceptedFileTypes=".pdf,.txt,.doc,.docx,.csv,.xls,.xlsx"
                    maxFileSize={10 * 1024 * 1024}
                    attachmentLabel="Upload Discussion Guide"
                    className="customChatBox"
                    buildPrompt="buildPrompt"
                    onPromptBuilderClick={showPromptBuilder}
                    onPromptLibraryClick={showPromptLibraryDrawer}
                  />
                </PromptSection>
                {/* <ThemeInput
                  className="placeholderItalic rounded shadow mt-6"
                  size="large"
                  placeholder="Ask anything about your project"
                  suffix={
                    <>
                      <ThemeFilterBtn
                        className="noStyle bgTransparent"
                        type="text"
                        size="small"
                        icon={<img src="/images/voice-icon.svg" />}
                      />

                      <ThemeFilterBtn
                        className="background"
                        onClick={() => navigate("/insight-engine/gpt")}
                        size="large"
                        shape="circle"
                        icon={<img src="/images/send-icon.svg" alt="Send" />}
                      />
                    </>
                  }
                /> */}
              </Col>
              <Col xs={{ span: 24, offset: 0 }}>
                <ProjectSuggestionsTitle>
                  Today’s suggested prompt
                </ProjectSuggestionsTitle>
              </Col>
              <Col xs={{ span: 24, offset: 0 }} className="text-center">
                <DefaultGptSuggestionsCard className="gradient-purple">
                  <Space>
                    <img src="/images/filter-icon.svg" alt="" />
                    Measuring results and turning data into actionable
                    learnings.
                  </Space>
                </DefaultGptSuggestionsCard>
                <br />
                <DefaultGptSuggestionsCard className="gradient-orange">
                  <Space>
                    <img src="/images/suggestion-icon-1.svg" alt="" />
                    Gather feedback, measure impact, and learn.
                  </Space>
                </DefaultGptSuggestionsCard>
                <br />
                <DefaultGptSuggestionsCard className="gradient-orange">
                  <Space>
                    <img src="/images/suggestion-icon-2.svg" alt="" />
                    Identify trends, topics, and sentiments.
                  </Space>
                </DefaultGptSuggestionsCard>
              </Col>
            </Row>
          </DefaultGptCard>
      </ThemeMainWrapper>

      {/* To do: History Drawer */}
      <ThemeDrawer
        title={
          <Space>
            <img src="/images/massage-icon.svg" alt="History" />
            Chat History
          </Space>
        }
        closable={{ placement: 'end' }}
        onClose={onHistoryClose}
        open={historyOpen}
        width="500px"
      >
        <div className="para1 mb-4">Choose which file you want to chat with. select one file or select all to analyze its data.</div>
        <ThemeInput
          className="shadow"
          placeholder="Search insights engine sessions..."
          size="large"
          shape="square"
          prefix={<SearchOutlined />}                          
        />
        <Divider/>
        <HistoryList>
          <HistoryItem>
            <div className="history-left">
              <div className="messages-info">
                <img src="/images/comment-icon.svg" alt="Messages" />
                <span>20 Messages</span>
              </div>
              <p className="topic-title">Planning Report Discussion</p>
            </div>
            <div className="history-right">
              <img src="/images/history-icon.svg" alt="History" />
              <span>2 days ago</span>
            </div>
          </HistoryItem>
          <HistoryItem>
            <div className="history-left">
              <div className="messages-info">
                <img src="/images/comment-icon.svg" alt="Messages" />
                <span>10 Messages</span>
              </div>
              <p className="topic-title">Community Feedback Review</p>
            </div>
            <div className="history-right">
              <img src="/images/history-icon.svg" alt="History" />
              <span>4 days ago</span>
            </div>
          </HistoryItem>
          <HistoryItem>
            <div className="history-left">
              <div className="messages-info">
                <img src="/images/comment-icon.svg" alt="Messages" />
                <span>30 Messages</span>
              </div>
              <p className="topic-title">Grasping Gen-Z's Mindset in NYC</p>
            </div>
            <div className="history-right">
              <img src="/images/history-icon.svg" alt="History" />
              <span>5 days ago</span>
            </div>
          </HistoryItem>
          <HistoryItem>
            <div className="history-left">
              <div className="messages-info">
                <img src="/images/comment-icon.svg" alt="Messages" />
                <span>40 Messages</span>
              </div>
              <p className="topic-title">Exploring New York's Youth...</p>
            </div>
            <div className="history-right">
              <img src="/images/history-icon.svg" alt="History" />
              <span>6 days ago</span>
            </div>
          </HistoryItem>
          <HistoryItem>
            <div className="history-left">
              <div className="messages-info">
                <img src="/images/comment-icon.svg" alt="Messages" />
                <span>40 Messages</span>
              </div>
              <p className="topic-title">Planning Report Discussion</p>
            </div>
            <div className="history-right">
              <img src="/images/history-icon.svg" alt="History" />
              <span>6 days ago</span>
            </div>
          </HistoryItem>
        </HistoryList>
      </ThemeDrawer>
      
      {/* To do: Prompt Library Drawer */}
      <ThemeDrawer
        title={
          <Space>
            <img src="/images/prompt-lib-icon.svg" alt="History" />
            Prompt Library
          </Space>
        }
        closable={{ placement: 'end' }}
        onClose={onPromptLibraryClose}
        open={promptLibraryOpen}
        width={500}
      >
        <div className="para1 mb-4">Develop a tailored prompt library that aligns specifically with your subject matter.</div>
        <XThemeSelect
          className="fullWidth noRadius"
          size="large"
          defaultValue="Approval Rating"
          options={[
            { value: '1', label: 'Approval Rating' },
            { value: '2', label: 'Lucy' },
            { value: '3', label: 'yiminghe' },
            { value: '4', label: 'Disabled', disabled: true },
          ]}
          showSearch={{
            filterOption: (input, option) =>
              (option?.label ?? '').toLowerCase().includes(input.toLowerCase()),
          }}
        />
        <Divider/>
        <div className="heading mb-3">Approval & Favorability</div>
        <LibraryList>
          <div className="listItems">
             <PlusSquareFilled />
             <div>Show <span>approval trends</span> for <span>Joe Biden</span> among <span>Gen Z</span> voters over the <span>past 6 months</span>.</div>
          </div>

          <div className="listItems">
             <PlusSquareFilled />
             <div>Compare <span>favorability</span> of the <span>Democratic Party</span> vs. <span>Republican Party</span> among <span>Gen Z women</span> nationwide.</div>
          </div>          
        </LibraryList>

        <div className="heading mb-3">Trust & Credibility</div>
        <LibraryList>
          <div className="listItems">
             <PlusSquareFilled />
             <div>What’s the <span>level of trust</span> in <span>mainstream media</span> among <span>Gen Z voters in swing states?</span></div>
          </div>

          <div className="listItems">
             <PlusSquareFilled />
             <div>Show <span>trust in government institutions</span> among <span>Gen Z men</span> vs. <span>Millennials</span> since the <span>2024 election</span>.</div>
          </div>          
        </LibraryList>

        <div className="heading mb-3">Trust & Credibility</div>
        <LibraryList>
          <div className="listItems">
             <PlusSquareFilled />
             <div>What’s the <span>level of trust</span> in <span>mainstream media</span> among <span>Gen Z voters in swing states?</span></div>
          </div>

          <div className="listItems">
             <PlusSquareFilled />
             <div>Show <span>trust in government institutions</span> among <span>Gen Z men</span> vs. <span>Millennials</span> since the <span>2024 election</span>.</div>
          </div>          
        </LibraryList>
      </ThemeDrawer>

      <ThemeDrawer
        title={
          <Space>
            <img src="/images/select-uploaded-files-icon.svg" alt="History" />
            Select Projects Files
          </Space>
        }
        closable={{ placement: 'end' }}
        onClose={onPromptUploadClose}
        open={promptUpload}
        width={500}
      >
        <div className="para1 mb-4">Choose which file you want to chat with. select one file or select all to analyze its data.</div>
        <ThemeInput
          className="shadow"
          placeholder="Search file by name"
          size="large"
          shape="square"
          prefix={<SearchOutlined />}                          
        />
        <Divider/>
        <ProjectFiles>
          data
        </ProjectFiles>
      </ThemeDrawer>

      {/* To do: Prompt Builder Modal */}
      <ThemeModal
          title={
            <Space>
              <img src="/images/shine-icon.svg" alt="History" />
              Prompt Builder
            </Space>
          }
          open={promptBuilderOpen}
          onCancel={onPromptBuilderClose}
          width={700}
          centered
          footer={false}
        >
        <ThemeForm layout="vertical">
            <Row gutter={[16, 0]}>
              <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                <ThemeForm.Item label="Metric">
                  <XThemeSelect
                    className="fullWidth noRadius"
                    size="large"
                    defaultValue="Approval Rating"
                    options={[
                      { value: '1', label: 'Approval Rating' },
                      { value: '2', label: 'Lucy' },
                      { value: '3', label: 'yiminghe' },
                      { value: '4', label: 'Disabled', disabled: true },
                      { value: 'disabled', label: 'Disabled', disabled: true },
                    ]}
                  />
                </ThemeForm.Item>
              </Col>
              <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                <ThemeForm.Item label="Entity / Subject">
                  <XThemeSelect
                    className="fullWidth noRadius"
                    size="large"
                    defaultValue="Independent Candidates"
                    options={[
                      { value: '1', label: 'Independent Candidates' },
                      { value: '2', label: 'Lucy' },
                      { value: '3', label: 'yiminghe' },
                      { value: '4', label: 'Disabled', disabled: true },
                    ]}
                  />
                </ThemeForm.Item>
              </Col>
              <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                <ThemeForm.Item label="Audience">
                  <XThemeSelect
                    className="fullWidth noRadius"
                    size="large"
                    defaultValue="Gen Z"
                    options={[
                      { value: '1', label: 'Gen Z' },
                      { value: '2', label: 'Lucy' },
                      { value: '3', label: 'yiminghe' },
                      { value: '4', label: 'Disabled', disabled: true },
                    ]}
                  />
                </ThemeForm.Item>
              </Col>
              <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                <ThemeForm.Item label="Audience">
                  <XThemeSelect
                    className="fullWidth noRadius"
                    size="large"
                    defaultValue="Region"
                    options={[
                      { value: '1', label: 'Region' },
                      { value: '2', label: 'Lucy' },
                      { value: '3', label: 'yiminghe' },
                      { value: '4', label: 'Disabled', disabled: true },
                    ]}
                  />
                </ThemeForm.Item>
              </Col>
              <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                <ThemeForm.Item label="Audience">
                  <XThemeSelect
                    className="fullWidth noRadius"
                    size="large"
                    defaultValue="Time Range"
                    options={[
                      { value: '1', label: 'Time Range' },
                      { value: '2', label: 'Lucy' },
                      { value: '3', label: 'yiminghe' },
                      { value: '4', label: 'Disabled', disabled: true },
                    ]}
                  />
                </ThemeForm.Item>
              </Col>            
            </Row>
            <Divider/>
            <Row>
              <Col xs={24}>
                <PromptSection className="pt-4">
                  <ChatBox
                    placeholder="Ask anything about your project"
                    minHeight={40}
                    acceptedFileTypes=".pdf,.txt,.doc,.docx,.csv,.xls,.xlsx"
                    maxFileSize={10 * 1024 * 1024}
                    attachmentLabel="Upload Discussion Guide"
                    className="customChatBox"
                    buildPrompt="buildPrompt"
                    libraryPrompt="library"
                    onPromptBuilderClick={showPromptBuilder}
                    value={`Show approval trends for Independent Candidates among Gen Z over the last 3 months.`}
                    onPromptLibraryClick={showPromptLibraryDrawer}
                  />
                </PromptSection>
              </Col>
            </Row>
        </ThemeForm>
      </ThemeModal>
    </>
  );
};

export default DefaultGpt;
